'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Step(number, title, text) {
  this.i4 = null;
  this.i6 = null;
  this.i5 = null;
  this.i4 = number;
  this.i6 = title;
  this.i5 = text;
}
export { $c_Lio_intela_sites_intelacloud_content_Step as $c_Lio_intela_sites_intelacloud_content_Step };
$p = $c_Lio_intela_sites_intelacloud_content_Step.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Step;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Step() {
}
export { $h_Lio_intela_sites_intelacloud_content_Step as $h_Lio_intela_sites_intelacloud_content_Step };
$h_Lio_intela_sites_intelacloud_content_Step.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 70761477, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Step) && (((this.i4 === x$0.i4) && (this.i6 === x$0.i6)) && (this.i5 === x$0.i5))));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "Step";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.i4;
      break;
    }
    case 1: {
      return this.i6;
      break;
    }
    case 2: {
      return this.i5;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Step(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bH)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Step as $isArrayOf_Lio_intela_sites_intelacloud_content_Step };
var $d_Lio_intela_sites_intelacloud_content_Step = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Step, "io.intela.sites.intelacloud.content.Step", ({
  bH: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Step as $d_Lio_intela_sites_intelacloud_content_Step };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Step.js.map
